export default __webpack_public_path__ + "static/media/IMG_6323.8f67d4dc.JPG";